module.exports = __webpack_public_path__ + "static/media/download-ico.66ea71ce.svg";